<ng-container *transloco="let t; read: 'scanner'">
  @if (vm$ | async; as vm) {
    <h2>{{t('title')}}</h2>
    @if (!scanditScannerReady) {
      <div id="lib-loading">
        <br />{{t('scannerIsLoading')}}
      </div>
    }
    <div class="scannerWrapper" >
      <scandit-barcode-picker
        #barcodePicker
        id="barcode-picker"
        configure="false"
        configure.engineLocation="https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build/"
        scanningPaused="true"
        visible="false"
        playSoundOnScan="true"
        vibrateOnScan="true"
        scanSettings.enabledSymbologies='["ean8", "ean13", "upca", "upce", "data-matrix"]'
        guiStyle="none"
        objectFit="cover"
        (ready)="onReady()"
        (scan)="addScanToList($event)"
        (scanError)="onError($event)"
        >
      </scandit-barcode-picker>
    </div>
    @if (!showScanner && currentProduct) {
      <form [formGroup]="addToCartForm" (submit)="addToCart(vm.currentEmployee)" id="scannerResultForm">
        <!--
        <kendo-formfield *ngIf="isOnline">
          <h4>{{t('name')}}</h4>
          <span>{{currentProduct.name}}</span>
        </kendo-formfield>
        <kendo-formfield>
          <h4>{{t('internalNumber')}}</h4>
          <span>{{currentProduct.internalNumber}}</span>
        </kendo-formfield>
        <kendo-formfield>
          <h4>{{t('quantity')}}</h4>
          <kendo-numerictextbox
            [style.width.px]="80"
            [autoCorrect]="true"
            [min]="1"
            format="n0"
            [value]="1"
            [min]="1"
            formControlName="quantity">
          </kendo-numerictextbox>
        </kendo-formfield>
        -->
        @if (isOnline) {
          <kendo-formfield>
            <kendo-label><h4>{{t('name')}}</h4></kendo-label>
            <kendo-textbox
              formControlName="name"
              [readonly]="true"
              class="noBorder">
            </kendo-textbox>
          </kendo-formfield>
        }
        <kendo-formfield>
          <kendo-label><h4>{{t('internalNumber')}}</h4></kendo-label>
          <kendo-textbox
            formControlName="internalNumber"
            [readonly]="true"
            class="noBorder">
          </kendo-textbox>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label><h4>{{t('quantity')}}</h4></kendo-label>
          <kendo-numerictextbox
            [style.width.px]="80"
            [autoCorrect]="true"
            [min]="1"
            format="n0"
            [value]="1"
            [min]="1"
            formControlName="quantity">
          </kendo-numerictextbox>
        </kendo-formfield>
        <div class="rowContainer">
          <button kendoButton
            type="submit"
            [disabled]="addToCartForm.invalid || ((currentCompany?.tenantId == null) && isAdminView && (connectionState$ | async))"
            class="buttonPrimary">
            {{ t("addToCart") }}
          </button>
          <button kendoButton
            (click)="startScanner()"
            class="buttonSecondary">
            {{ t("cancel") }}
          </button>
        </div>
      </form>
    }
  }
</ng-container>
